module.exports = __webpack_public_path__ + "static/media/people-desc.bf7e00af.png";